// import { useSelf } from 'components/providers/SelfProvider'
import { useUser } from 'hooks/api/user/useUser'

export const useHasMoreThanDefaultGroups = (userSlug) => {
	// const { user } = useSelf()
	const { data: user } = useUser(userSlug)

	return user?.groupAccounts && user?.groupAccounts?.length > 1 ? true : false
}
